export enum SectionType {
    GI = 'general-info',
    TROPHY = 'github-trophy',
    ABOUT = 'about-me',
    LNT = 'languages-and-tools',
    STREAK = 'github-streak',
    STATS = 'github-stats',
    CONNECT = 'connect-with-me'
}